import api from 'api';

export const loadTypes = api('GET /api/annotations/fields/types');
export const loadSubTypes = api('GET api/annotations/fields/subtypes');
export const loadChannels = api('GET api/annotations/fields/channels');
export const loadApplications = api('GET /api/annotations/fields/applications');
export const loadAffiliates = api('GET /api/annotations/fields/affiliates');
export const loadNetworks = api('GET /api/annotations/fields/networks');
export const loadClusters = api('GET /api/annotations/fields/clusters');
export const loadPlatforms = api('GET /api/annotations/fields/platforms');
